let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aBPqh")).then(() => parcelRequire('6Kkwl'));